import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M9.9993 0.5L6.9428 6.7388L0 7.74555L5.02945 12.6625L3.8272 19.5L9.9993 16.2096L16.1727 19.5L14.9793 12.6625L20 7.74555L13.0956 6.7388L9.9993 0.5Z",
      fill: "#FFC635"
    }, null, -1)
  ]))]))
}
export default { render: render }